import React from 'react'
import { SearchOutlined } from '@mui/icons-material';
import { Button, Grid, IconButton, Paper, TextField } from '@mui/material';
import useDebounce from 'hooks/useDebounce';
import MainCard from 'ui-component/cards/MainCard';
import { deleteLanguage, getlanguage } from 'utils/APIs';
import Table from 'views/utilities/Table';
import Confirmation from 'views/utilities/Confirmation';
import { toast } from 'react-toastify';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';import CreateLanguage from './CreateLanguage';
import UpdateLanguage from './UpdateLanguage';

const ViewLanguage = () => {
    const { t } = useTranslation()

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [name, setName] = React.useState('');
    const [loading, setloading] = React.useState(true);
    const [languageData, setLanguageData] = React.useState()
    const debouncedSearchTerm = useDebounce(name, 500);
    const [languageCount, setLanguaCount] = React.useState(0)
    const [openForm, setopenForm] = React.useState(false)
    const [selectedRow, setselectedRow] = React.useState(null);
    const [updateData, setupdateRow] = React.useState()
    const [openUpdateForm, setOpenUpdateForm] = React.useState(false)
    const theme = useTheme()

    const getLanguageData = async () => {
        setloading(true);
        const data = await getlanguage(rowsPerPage, page + 1, name);
        setLanguageData(data?.data?.results)
        setLanguaCount(data?.data?.totalResults)
        setloading(false);
    }

    React.useEffect(() => {
        getLanguageData()
    }, [rowsPerPage, page + 1, debouncedSearchTerm])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleOpenForm = (e) => {
        e.preventDefault()
        setopenForm(true)
    }

    const columns = [
        {
            id: 'name',
            label: t('Language'),
            minWidth: 170
        },
        {
            id: 'code',
            label: t('Code'),
            minWidth: 170
        },
        {
            id: 'action',
            label: t('Action'),
            minWidth: 170,
            align: 'center'
        }
    ];
    const onClickDelete = (selectedUser) => {
        setselectedRow(selectedUser);
    };
    const handleConfirm = async () => {
        try {
            await deleteLanguage(selectedRow?.id);
            toast.success('Language deleted successfully');
            getLanguageData()

        } catch (error) {
            toast.error(error.message);
            getLanguageData()

        } finally {
            setselectedRow(null);
        }
    };

    const handleOpenUpdateForm = (e, selectedRow,) => {
        e.preventDefault()
        setOpenUpdateForm(true)
        setupdateRow(selectedRow)
    }
    return (
        <div>
            <div>
                <Confirmation
                    open={selectedRow !== null}
                    handleClose={() => setselectedRow(null)}
                    handleConfirm={handleConfirm}
                    title="Delete Confirmation"
                    itemName={selectedRow?.name}
                />
                <CreateLanguage
                    open={openForm}
                    setopenForm={setopenForm}
                />
                <UpdateLanguage
                    open={openUpdateForm}
                    setopenForm={setOpenUpdateForm}
                    itemName={updateData}
                    setselectedRow={setupdateRow}
                    getLanguageData={getLanguageData}
                />
                <MainCard title={t("View Industry")}>
                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} sx={{ alignItems: 'center' }}
                        >
                            <Grid item xs={7}>
                                <TextField
                                    fullWidth
                                    sx={{ ...theme.typography.customInput }}
                                    id="standard-bare"
                                    variant="outlined"
                                    placeholder={t("Search")}
                                    onChange={(e) => setName(e?.target?.value)}
                                    value={name}
                                    InputProps={{
                                        endAdornment: (
                                            <IconButton>
                                                <SearchOutlined />
                                            </IconButton>
                                        )
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <Button
                                    sx={{ borderRadius: 3, background: '#fafafa', padding: '10px 18px' }}
                                    disableElevation
                                    onClick={(e) => handleOpenForm(e)}
                                    variant="outlined"
                                    color="secondary">
                                    {t("Generate")}
                                </Button>
                            </Grid>
                        </Grid>
                        <Table
                            columns={columns}
                            loading={loading}
                            data={languageData}
                            totalCount={languageCount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            handleChangePage={handleChangePage}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                            onClickDelete={onClickDelete}
                            type='country'
                            onClickEdit={handleOpenUpdateForm}
                        />
                    </Paper>
                </MainCard></div>
        </div>
    )
}

export default ViewLanguage